import { FC } from 'react';

import { CertificationButtonStyled, CertificationButtonWrapStyled } from './Certification.styled';
import CertifiedIcon from 'icons/CertifiedIcon';

const Certification: FC = () => (
  <CertificationButtonWrapStyled title="Chirp Certified">
    <CertificationButtonStyled
      variant="contained"
      icon={<CertifiedIcon color="gold" size="2xl" />}
    />
  </CertificationButtonWrapStyled>
);

export default Certification;
